import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import { Link, SocialShare } from "@quintype/components";
import { SocialShareTemplate } from "../../../arrow";

import { STATIC_KEYWORDS } from "../../../constants";
import { DataCard } from "../../atoms/DataCard";
import RankingTrendGraph from "../../molecules/Graph";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { Badge } from "./badge";
import ThreeColGrid from "../../../arrow/components/Rows/ThreeColGrid";
import { getAdvancedSearchItems } from "../../../../api/utils";
import { STORY_HEADER_IN_VIEW } from "../../store/actions";
import ListingAdSlot from "../../molecules/ListingAdSlot";
import CompanyIcon from "../../atoms/CompanyIcon";
import { useScrollToElement } from "../../customHooks/useScrollToElement";
import { trackLoadMoreClick } from "../../utils";
import ArrowDashIcon from "../../atoms/Arrow-DashIcon";

import "./company-page.m.css";

const CompanyPage = ({ data = [], config }) => {
  const cdnImage = `https://${config?.["cdn-image"]}`;
  const dispatch = useDispatch();
  const allStates = useSelector((state) => state);

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfreePage = get(qtState, ["config", "subscriber"]) === "true";

  const storyHeaderInView = get(allStates, "storyHeaderInView", true);
  const { sortedCombinedSnapshots, tagResponse, slug, companyInfo } = data;
  const isMobile = useDeviceType() !== "desktop";
  const fortune500BadgeData = companyInfo.fortune500ranks ? JSON.parse(companyInfo.fortune500ranks) : [];
  const fortune500BadgeRanks = fortune500BadgeData.map((item) => {
    const yearKey = Object.keys(item).find((key) => !["headline", "profile", "byline"].includes(key));
    return { type: "Fortune 500 ", year: Number(yearKey), rank: Number(item[yearKey]) };
  });
  const next500BadgeData = companyInfo.next500ranks ? JSON.parse(companyInfo.next500ranks) : [];
  const next500BadgeRanks = next500BadgeData.map((item) => {
    const yearKey = Object.keys(item).find((key) => !["headline", "profile", "byline"].includes(key));
    return { type: "Next 500 ", year: Number(yearKey), rank: Number(item[yearKey]) };
  });
  const emergingCompaniesBadgeData = companyInfo.emergingcompaniesranks
    ? JSON.parse(companyInfo.emergingcompaniesranks)
    : [];
  const emergingCompaniesBadgeRanks = emergingCompaniesBadgeData.map((item) => {
    const yearKey = Object.keys(item).find((key) => !["headline", "profile", "byline"].includes(key));
    return { type: "The Emerging Companies ", year: Number(yearKey), rank: Number(item[yearKey]) };
  });
  const badgeData = fortune500BadgeRanks
    .concat(next500BadgeRanks)
    .concat(emergingCompaniesBadgeRanks)
    .sort((a, b) => b.year - a.year);
  const { OVERVIEW, FINANCIALS, NEWS_CAPITAL } = STATIC_KEYWORDS;
  const [screen, setScreen] = useState(1);
  const [fgRevenue, setFGRevenue] = useState(true);
  const [fgNOI, setFGNOI] = useState(true);
  const [fgProfit, setFGProfit] = useState(true);
  const [fgAsset, setFGAsset] = useState(true);
  const [fgNW, setFGNW] = useState(true);
  const [kfgProfitIncome, setKFGProfitIncome] = useState(true);
  const [kfgEbitda, setKFGEbitda] = useState(true);
  const [kfgRonw, setKFGRonw] = useState(true);
  const [kfgRoce, setKFGRoce] = useState(true);
  const [kfgTsr, setKFGTsr] = useState(true);
  const [offset, setOffset] = useState(6);
  const entityStories = tagResponse.items.slice(0, 6);
  const [entityStoriesMax, setEntityStoriesMax] = useState(tagResponse.items);
  const companyHeader = useRef(null);

  const [graphExpand1, setGraphExpand1] = useState(false);
  const [graphExpand2, setGraphExpand2] = useState(false);
  const [graphExpand3, setGraphExpand3] = useState(false);
  const [graphExpand4, setGraphExpand4] = useState(false);
  const [graphExpand5, setGraphExpand5] = useState(false);
  const [graphExpand6, setGraphExpand6] = useState(false);

  let fortune500GraphData = [];
  let next500GraphData = [];
  let emergingCompaniesGraphData = [];
  const [url, setUrl] = useState("");

  const featuredRef = useRef(null);
  const scrollToFeatured = useScrollToElement(featuredRef);

  //
  const scrollContainerRef1 = useRef(null);
  const scrollContainerRef2 = useRef(null);
  const [canScrollLeft1, setCanScrollLeft1] = useState(false);
  const [canScrollRight1, setCanScrollRight1] = useState(true);
  const [canScrollLeft2, setCanScrollLeft2] = useState(false);
  const [canScrollRight2, setCanScrollRight2] = useState(true);
  const scrollTable = (direction) => {
    const container1 = scrollContainerRef1.current;
    if (!container1) return;

    const scrollAmount = 350;
    container1.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };
  const scrollTable2 = (direction) => {
    const container2 = scrollContainerRef2.current;
    if (!container2) return;
    const scrollAmount = 350;
    container2.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };
  const updateScrollState1 = () => {
    const container1 = scrollContainerRef1.current;
    if (!container1) return;
    setCanScrollLeft1(container1.scrollLeft > 0);
    if (container1.scrollWidth) {
      setCanScrollRight1(!(container1.scrollLeft + container1.clientWidth + 1 > container1.scrollWidth));
    }
  };

  const updateScrollState2 = () => {
    const container2 = scrollContainerRef2.current;
    if (!container2) return;
    setCanScrollLeft2(container2.scrollLeft > 0);
    if (container2.scrollWidth) {
      setCanScrollRight2(!(container2.scrollLeft + container2.clientWidth + 1 > container2.scrollWidth));
    }
  };

  useEffect(() => {
    const container1 = scrollContainerRef1.current;
    if (!container1) return;
    updateScrollState1();
    container1.addEventListener("scroll", updateScrollState1);
    window.addEventListener("resize", updateScrollState1);
    return () => {
      container1.removeEventListener("scroll", updateScrollState1);
      window.removeEventListener("resize", updateScrollState1);
    };
  }, []);

  useEffect(() => {
    const container2 = scrollContainerRef2.current;
    if (!container2) return;
    updateScrollState2();
    container2.addEventListener("scroll", updateScrollState2);
    window.addEventListener("resize", updateScrollState2);
    return () => {
      container2.removeEventListener("scroll", updateScrollState2);
      window.removeEventListener("resize", updateScrollState2);
    };
  }, []);
  //

  const RenderBadge = ({ countCalculator, styles }) => {
    return (
      countCalculator > 0 && (
        <div onClick={scrollToFeatured} styleName={styles}>
          + {countCalculator} More
        </div>
      )
    );
  };

  const handleScroll = () => {
    const companyHeaderPosition = companyHeader.current.getBoundingClientRect();
    if (companyHeaderPosition.bottom < 75 && storyHeaderInView) {
      dispatch({
        type: STORY_HEADER_IN_VIEW,
        payload: false,
      });
    } else if (companyHeaderPosition.bottom > 75 && !storyHeaderInView) {
      dispatch({
        type: STORY_HEADER_IN_VIEW,
        payload: true,
      });
    }
  };

  // Track company detail interactions
  let isTracking = false;
  const trackCompanyDetailInteraction = (action, value) => {
    if (isTracking) return;
    isTracking = true;
    setTimeout(() => {
      isTracking = false;
    }, 300);
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_company_detail_interactions",
        event_action: action,
        link_text: value?.toLowerCase(),
        category: "companies",
        sub_category: companyInfo?.name?.toLowerCase() || "NA",
        template_name: "profilepage",
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
      });
    }
  };

  const throttledHandleScroll = throttle(handleScroll, 200);
  useEffect(() => {
    window.addEventListener("scroll", throttledHandleScroll);
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
      throttledHandleScroll.cancel();
    };
  }, [throttledHandleScroll]);

  useEffect(() => {
    setUrl(window.location.href);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "companies",
      sub_category: companyInfo?.name || "NA",
      content_id: "NA",
      template_name: "profilepage",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  const getMoreStories = async (offset, limit) => {
    trackLoadMoreClick({
      linkCategory: "companies",
      category: "companies",
      subCategory: companyInfo?.name?.toLowerCase() || "NA",
      templateName: "profilepage",
    });
    const splitTagSlug = slug.split("-").join(" ");
    const tagResults = await getAdvancedSearchItems("tag-name-lower", splitTagSlug, entityStoriesMax?.length, 5);
    const getStories = tagResults?.map((item) => item.story);

    setOffset(offset + 12);
    setEntityStoriesMax(entityStoriesMax.concat(getStories));
  };

  const handleBagdes = (scrollToFeatured) => {
    if (badgeData.length) {
      const countCalculator = badgeData.length - (isMobile ? 1 : 2);
      return (
        <>
          <div styleName="badges-container">
            {badgeData
              .map((rank, index) => {
                return (
                  <div
                    key={index}
                    styleName={`badge ${rank.type === "Fortune 500 " ? "fortune500" : "next500"}`}
                    ref={index === 0 ? featuredRef : null}
                    onClick={() => {
                      trackCompanyDetailInteraction("badge_clicks", `${rank.type}${rank.year}`);
                      scrollToFeatured();
                    }}
                  >
                    <Badge />
                    <span>
                      {rank.type}
                      {rank.year}
                    </span>
                  </div>
                );
              })
              .slice(0, isMobile ? 1 : 2)}
            <RenderBadge countCalculator={countCalculator} styles="count-desktop" />
          </div>
          <div style={{ lineHeight: 0 }}>
            <RenderBadge countCalculator={countCalculator} styles="count-mobile" />
          </div>
        </>
      );
    }
  };

  const employeeGraphData = sortedCombinedSnapshots
    .filter((obj) => obj["employee-count"] !== undefined && obj["employee-count"] !== null)
    .map((obj) => ({
      year: obj["generic-company-snapshot-year"]?.name,
      value: obj["employee-count"],
    }))
    .reverse();

  const {
    name,
    bio,
    photo,
    "year-of-incorporation": yearOfIncorporation,
    headquarters,
    employees = sortedCombinedSnapshots?.[0]?.["employee-count"] || "",
    owner = sortedCombinedSnapshots?.[0]?.owership,
    "company-industry": companyIndustry = "Industry",
    website,
  } = companyInfo;

  if (fortune500BadgeData.length) {
    fortune500GraphData = fortune500BadgeData
      .map((obj) => ({
        year: JSON.parse(Object.keys(obj)[0]),
        value: JSON.parse(Object.values(obj)[0]),
      }))
      .sort((a, b) => a.year - b.year);
  }

  if (next500BadgeData.length) {
    next500GraphData = next500BadgeData
      .map((obj) => ({
        year: JSON.parse(Object.keys(obj)[0]),
        value: JSON.parse(Object.values(obj)[0]),
      }))
      .sort((a, b) => a.year - b.year);
  }

  if (emergingCompaniesBadgeData.length) {
    emergingCompaniesGraphData = emergingCompaniesBadgeData
      .map((obj) => ({
        year: JSON.parse(Object.keys(obj)[0]),
        value: JSON.parse(Object.values(obj)[0]),
      }))
      .sort((a, b) => a.year - b.year);
  }

  const sectionSwitch = () => {
    setScreen(3);
    setTimeout(() => {
      window.scrollTo({ top: isMobile ? 650 : 120, behavior: "smooth" });
    }, 150);
  };

  const dynamicOptionsFG = [
    { name: "Revenue", key: "revenue", color: "#6B7FFE", value: fgRevenue, setvalue: setFGRevenue },
    { name: "Net Operating Income", key: "net-operating-income", color: "#d56012b3", value: fgNOI, setvalue: setFGNOI },
    { name: "Profit", key: "profit", color: "#ff11e399", value: fgProfit, setvalue: setFGProfit },
    { name: "Assets", key: "assets", color: "#80CA2B", value: fgAsset, setvalue: setFGAsset },
    { name: "Net Worth", key: "networth", color: "#1EE9BD", value: fgNW, setvalue: setFGNW },
  ];

  dynamicOptionsFG.forEach((item) => {
    const validCount = sortedCombinedSnapshots.filter(
      (obj) => obj[item.key] !== undefined && obj[item.key] !== null && obj[item.key] !== "-" && obj[item.key] !== ""
    ).length;

    item.present = validCount >= 2;
  });

  const dynamicOptionsKFG = [
    {
      name: "Profit As % Of Revenues",
      color: "#6B7FFE",
      value: kfgProfitIncome,
      setvalue: setKFGProfitIncome,
      key: "profit-as-%-of-revenues",
    },
    { name: "RONW %", color: "#ff11e399", value: kfgRonw, setvalue: setKFGRonw, key: "ronw" },
    {
      name: "Interest Cost to EBITDA %",
      color: "#d56012b3",
      value: kfgEbitda,
      setvalue: setKFGEbitda,
      key: "interest-cost-to-ebitda-%",
    },
    { name: "ROCE %", color: "#80CA2B", value: kfgRoce, setvalue: setKFGRoce, key: "roce" },
    { name: "Debt to Equity Ratio", color: "#1EE9BD", value: kfgTsr, setvalue: setKFGTsr, key: "debt-to-equity-ratio" },
  ];
  dynamicOptionsKFG.forEach((item) => {
    const validCount = sortedCombinedSnapshots.filter(
      (obj) => obj[item.key] !== undefined && obj[item.key] !== null && obj[item.key] !== "-" && obj[item.key] !== ""
    ).length;

    item.present = validCount >= 2;
  });

  const companyStatics = () => {
    const photoArray = photo?.[0];
    const photoUrl = photoArray?.key || undefined;
    return (
      <div styleName={`company-top ${isAdfreePage ? "no-ad-company-top" : ""}`} ref={companyHeader}>
        <div styleName="info-container">
          <div styleName="name-logo-container">
            <div styleName="logo">
              {photoUrl ? (
                <img styleName="image" src={`${cdnImage}/${photoUrl}?w=512&q=70`} />
              ) : (
                <span styleName="placeholder">
                  <CompanyIcon />
                </span>
              )}
            </div>
            <div styleName="name">
              <div styleName="name-badge">
                <h1>{name}</h1>
                {handleBagdes(scrollToFeatured)}
              </div>
              <div className="content-style">
                <SocialShare
                  popupText="Share this URL"
                  template={SocialShareTemplate}
                  onShareClick={(platform) => {
                    return trackCompanyDetailInteraction("share_click", platform?.toLowerCase() || "share");
                  }}
                  fullUrl={encodeURI(url)}
                  title={`${name} on Fortune India`}
                  shareIconId={`share-icon-company-share`}
                  shareText={true}
                />
              </div>
            </div>
          </div>
          {!isAdfreePage && (
            <div styleName="mobile-ad">
              <ListingAdSlot
                adType="right_side"
                pageType={"company-page"}
                adStyleName="ad-slot-size-300x250"
                index={1}
                adSlotConfigName={"mRec_ad"}
                showText={false}
              />
            </div>
          )}
          <div styleName="section-container">
            <div
              styleName={`section ${screen === 1 ? "active" : ""}`}
              onClick={() => {
                setScreen(1);
                trackCompanyDetailInteraction("tab_switch", "Overview");
              }}
            >
              {OVERVIEW}
            </div>
            {sortedCombinedSnapshots?.length > 0 && (
              <div
                styleName={`section ${screen === 2 ? "active" : ""}`}
                onClick={() => {
                  setScreen(2);
                  trackCompanyDetailInteraction("tab_switch", "Financials");
                }}
              >
                {FINANCIALS}
              </div>
            )}
            {tagResponse.total > 0 && (
              <div
                styleName={`section ${screen === 3 ? "active" : ""}`}
                onClick={() => {
                  setScreen(3);
                  trackCompanyDetailInteraction("tab_switch", "News");
                }}
              >
                {NEWS_CAPITAL}
              </div>
            )}
          </div>
        </div>
        {!isAdfreePage && (
          <div styleName="desktop-ad">
            <ListingAdSlot
              adType="right_side"
              pageType={"company-page"}
              adStyleName="ad-style-300x250"
              index={2}
              adSlotConfigName={"mRec_ad"}
              showText={false}
            />
          </div>
        )}
      </div>
    );
  };

  const aboutCompany = () => {
    return (
      <section styleName="about-section">
        <h2>About</h2>
        <p>{bio}</p>
        <div styleName="company-info-grid">
          {yearOfIncorporation && (
            <div styleName="info-column">
              <span styleName="label">Incorporation Year:</span> <span styleName="value">{yearOfIncorporation}</span>
            </div>
          )}
          {headquarters && (
            <div styleName="info-column">
              <span styleName="label">Headquarters:</span> <span styleName="value">{headquarters}</span>
            </div>
          )}
          {employees && (
            <div styleName="info-column">
              <span styleName="label">Employees:</span> <span styleName="value">{employees}</span>
            </div>
          )}
          {owner && (
            <div styleName="info-column">
              <span styleName="label">Top Management:</span> <span styleName="value">{owner}</span>
            </div>
          )}
          {companyIndustry?.name && (
            <div styleName="info-column">
              <span styleName="label">Industry:</span> <span styleName="value">{companyIndustry?.name}</span>
            </div>
          )}
          {website && (
            <div styleName="info-column">
              <span styleName="label">Website: </span>
              <Link href={`https://${website}`} target="_blank" rel="nofollow">
                <span styleName="value">{website}</span>
              </Link>
            </div>
          )}
        </div>
      </section>
    );
  };

  const featuredRankingBlock = () => {
    const fortune500BadgeDataSorted = fortune500BadgeData.sort((a, b) => {
      const yearA = parseInt(Object.keys(a)[0]);
      const yearB = parseInt(Object.keys(b)[0]);
      return yearB - yearA;
    });
    const next500BadgeDataSorted = next500BadgeData.sort((a, b) => {
      const yearA = parseInt(Object.keys(a)[0]);
      const yearB = parseInt(Object.keys(b)[0]);
      return yearB - yearA;
    });
    const emergingCompaniesBadgeDataSorted = emergingCompaniesBadgeData.sort((a, b) => {
      const yearA = parseInt(Object.keys(a)[0]);
      const yearB = parseInt(Object.keys(b)[0]);
      return yearB - yearA;
    });
    return (
      (fortune500BadgeDataSorted.length ||
        next500BadgeDataSorted.length ||
        emergingCompaniesBadgeDataSorted.length > 0) && (
        <section
          ref={featuredRef}
          styleName={`fortune-section ${
            !(bio || yearOfIncorporation || headquarters || employees || owner || companyIndustry?.name || website)
              ? "without-about"
              : ""
          }`}
        >
          <h2>Featured In Fortune India Ranking</h2>
          {fortune500BadgeDataSorted.length > 0 && (
            <React.Fragment>
              <div styleName="fortune-header">
                <div styleName="fortune-logo">
                  <a href="/rankings/fortune-500">
                    <img styleName="image" src="/images/logos-square/fortune-500.png" />
                  </a>
                </div>
                <div styleName="rankings-data">
                  <a styleName="heading" href="/rankings/fortune-500">
                    Fortune 500 India
                  </a>
                  <div styleName="rankings">
                    {fortune500BadgeDataSorted.map((obj, index) => (
                      <div key={index} style={{ minWidth: "fit-content" }}>
                        <span styleName="rank">
                          {"#"}
                          {Object.values(obj)[0]}
                        </span>
                        <span styleName="year">({Object.keys(obj)[0]})</span>
                        {index !== fortune500BadgeDataSorted.length - 1 && <span styleName="line" />}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div styleName="rankings-mobile">
                {fortune500BadgeDataSorted.map((obj, index) => (
                  <span key={index}>
                    <span styleName="rank">
                      {"#"}
                      {Object.values(obj)[0]}
                    </span>
                    <span styleName="year">({Object.keys(obj)[0]})</span>
                    {index !== fortune500BadgeDataSorted.length - 1 && <span styleName="line" />}
                  </span>
                ))}
              </div>
            </React.Fragment>
          )}
          {fortune500BadgeData.length > 1 && (
            <div styleName="graph-placeholder">
              <RankingTrendGraph
                reversed={false}
                graphData={fortune500GraphData}
                title={"Ranking Trend Fortune 500 India"}
                graphExpand={graphExpand1}
                setGraphExpand={setGraphExpand1}
              />
            </div>
          )}
          {emergingCompaniesBadgeDataSorted.length > 0 && (
            <React.Fragment>
              <div styleName="fortune-header">
                <div styleName="fortune-logo">
                  <a href="/rankings/the-emerging-companies">
                    <img styleName="image" src="/images/logos-square/the-emerging-companies.png" />
                  </a>
                </div>
                <div styleName="rankings-data">
                  <a styleName="heading" href="/rankings/the-emerging-companies">
                    The Emerging Companies
                  </a>
                  <div styleName="rankings">
                    {emergingCompaniesBadgeDataSorted.map((obj, index) => (
                      <div key={index} style={{ minWidth: "fit-content" }}>
                        <span styleName="rank">
                          {"#"}
                          {Object.values(obj)[0]}
                        </span>
                        <span styleName="year">({Object.keys(obj)[0]})</span>
                        {index !== emergingCompaniesBadgeDataSorted.length - 1 && <span styleName="line" />}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div styleName="rankings-mobile">
                {emergingCompaniesBadgeDataSorted.map((obj, index) => (
                  <span key={index}>
                    <span styleName="rank">
                      {"#"}
                      {Object.values(obj)[0]}
                    </span>
                    <span styleName="year">({Object.keys(obj)[0]})</span>
                    {index !== emergingCompaniesBadgeDataSorted.length - 1 && <span styleName="line" />}
                  </span>
                ))}
              </div>
            </React.Fragment>
          )}
          {emergingCompaniesBadgeData.length > 1 && (
            <div styleName="graph-placeholder">
              <RankingTrendGraph
                reversed={false}
                graphData={emergingCompaniesGraphData}
                title={"Ranking Trend Emerging Companies"}
                graphExpand={graphExpand6}
                setGraphExpand={setGraphExpand6}
              />
            </div>
          )}
          {next500BadgeDataSorted.length > 0 && (
            <React.Fragment>
              <div styleName="fortune-header">
                <div styleName="fortune-logo">
                  <a href="/rankings/the-next-500">
                    <img styleName="image" src="/images/logos-square/next-500.png" />
                  </a>
                </div>
                <div styleName="rankings-data">
                  <a styleName="heading" href="/rankings/the-next-500">
                    Next 500 India
                  </a>
                  <div styleName="rankings">
                    {next500BadgeDataSorted.map((obj, index) => (
                      <span key={index}>
                        <span styleName="rank">
                          {"#"}
                          {Object.values(obj)[0]}
                        </span>
                        <span styleName="year">({Object.keys(obj)[0]})</span>
                        {index !== next500BadgeDataSorted.length - 1 && <span styleName="line" />}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <div styleName="rankings-mobile">
                {next500BadgeDataSorted.map((obj, index) => (
                  <span key={index}>
                    <span styleName="rank">
                      {"#"}
                      {Object.values(obj)[0]}
                    </span>
                    <span styleName="year">({Object.keys(obj)[0]})</span>
                    {index !== next500BadgeDataSorted.length - 1 && <span styleName="line" />}
                  </span>
                ))}
              </div>
            </React.Fragment>
          )}
          {next500BadgeData.length > 1 && (
            <div styleName="graph-placeholder">
              <RankingTrendGraph
                reversed={false}
                graphData={next500GraphData}
                title={"Ranking Trend Fortune Next 500 India"}
                graphExpand={graphExpand2}
                setGraphExpand={setGraphExpand2}
              />
            </div>
          )}
        </section>
      )
    );
  };

  const latestFinancialCards = () => {
    const {
      revenue,
      assets,
      profit,
      networth,
      "net-operating-income": netOperatingIncome,
    } = sortedCombinedSnapshots?.[0] ?? {};
    return (
      <section styleName="financial-employee-section">
        <h2>Financial Data {sortedCombinedSnapshots?.[0]["generic-company-snapshot-year"]?.name}</h2>
        <div styleName="financial-grid">
          <DataCard name="Revenue" value={revenue} unit="(INR Cr)" />
          <DataCard name="Net Operating Income" value={netOperatingIncome} unit="(INR Cr)" />
          <DataCard name="Assets" value={assets} unit="(INR Cr)" />
          <DataCard name="Profit" value={profit} unit="(INR Cr)" />
          <DataCard name="Net Worth" value={networth} unit="(INR Cr)" />
        </div>
      </section>
    );
  };
  const { "employee-count": employeeCount, "employee-yoy": employeeYoY } = sortedCombinedSnapshots?.[0] ?? {};
  const employeeData = () => {
    return (
      <>
        <div styleName="financial-grid">
          {employeeCount && <DataCard name="No of Employees" value={employeeCount} />}
          {employeeYoY && <DataCard name="Change (vs Last Year)" value={employeeYoY} color={true} />}
        </div>
      </>
    );
  };

  const screen2GraphsRenderer = () => {
    let fgMIN = parseInt(sortedCombinedSnapshots?.[0].revenue?.replace(/,/g, ""), 10);
    let fgMAX = parseInt(sortedCombinedSnapshots?.[0].revenue?.replace(/,/g, ""), 10);
    let kfgMIN = sortedCombinedSnapshots?.[0]["profit-as-%-of-revenues"];
    let kfgMAX = sortedCombinedSnapshots?.[0]["profit-as-%-of-revenues"];

    const financialGraphData = sortedCombinedSnapshots
      .map((obj) => {
        const mappedObj = { year: obj["generic-company-snapshot-year"]?.name };
        if (fgRevenue) {
          const revenueNum = parseInt(obj.revenue?.replace(/,/g, ""), 10);
          mappedObj.value = revenueNum;
          mappedObj.valuecolor = "#6B7FFE";
          if (revenueNum <= fgMIN) {
            fgMIN = revenueNum;
          }
          if (revenueNum >= fgMAX) {
            fgMAX = revenueNum;
          }
        }
        if (fgNOI) {
          const noiNum = parseInt(obj["net-operating-income"]?.replace(/,/g, ""), 10);
          mappedObj.value1 = noiNum;
          mappedObj.value1color = "#d56012b3";
          if (noiNum <= fgMIN) {
            fgMIN = noiNum;
          }
          if (noiNum >= fgMAX) {
            fgMAX = noiNum;
          }
        }
        if (fgProfit) {
          const profitNum = parseInt(obj.profit?.replace(/,/g, ""), 10);
          mappedObj.value2 = profitNum;
          mappedObj.value2color = "#ff11e399";
          if (profitNum <= fgMIN) {
            fgMIN = profitNum;
          }
          if (profitNum >= fgMAX) {
            fgMAX = profitNum;
          }
        }
        if (fgAsset) {
          const assetsNum = parseInt(obj.assets?.replace(/,/g, ""), 10);
          mappedObj.value3 = assetsNum;
          mappedObj.value3color = "#80CA2B";
          if (assetsNum <= fgMIN) {
            fgMIN = assetsNum;
          }
          if (assetsNum >= fgMAX) {
            fgMAX = assetsNum;
          }
        }
        if (fgNW) {
          const networthNum = parseInt(obj.networth?.replace(/,/g, ""), 10);
          mappedObj.value4 = networthNum;
          mappedObj.value4color = "#1EE9BD";
          if (networthNum <= fgMIN) {
            fgMIN = networthNum;
          }
          if (networthNum >= fgMAX) {
            fgMAX = networthNum;
          }
        }
        return mappedObj;
      })
      .reverse();

    const keyfinancialGraphData = sortedCombinedSnapshots
      .map((obj) => {
        const mappedObj = { year: obj["generic-company-snapshot-year"]?.name };
        if (kfgProfitIncome) {
          mappedObj.value = obj["profit-as-%-of-revenues"];
          mappedObj.valuecolor = "#6B7FFE";
          if (parseFloat(obj["profit-as-%-of-revenues"]) <= kfgMIN) {
            kfgMIN = parseFloat(obj["profit-as-%-of-revenues"]);
          }
          if (parseInt(obj["profit-as-%-of-revenues"]) >= kfgMAX) {
            kfgMAX = parseInt(obj["profit-as-%-of-revenues"]);
          }
        }
        if (kfgEbitda) {
          mappedObj.value1 = obj["interest-cost-to-ebitda-%"];
          mappedObj.value1color = "#d56012b3";
          if (parseFloat(obj["interest-cost-to-ebitda-%"]) <= kfgMIN) {
            kfgMIN = parseFloat(obj["interest-cost-to-ebitda-%"]);
          }
          if (parseFloat(obj["interest-cost-to-ebitda-%"]) >= kfgMAX) {
            kfgMAX = parseFloat(obj["interest-cost-to-ebitda-%"]);
          }
        }
        if (kfgRonw) {
          mappedObj.value2 = obj.ronw;
          mappedObj.value2color = "#ff11e399";
          if (parseFloat(obj.ronw) <= kfgMIN) {
            kfgMIN = parseFloat(obj.ronw);
          }
          if (parseFloat(obj.ronw) >= kfgMAX) {
            kfgMAX = parseFloat(obj.ronw);
          }
        }
        if (kfgRoce) {
          mappedObj.value3 = obj.roce;
          mappedObj.value3color = "#80CA2B";
          if (parseFloat(obj.roce) <= kfgMIN) {
            kfgMIN = parseFloat(obj.roce);
          }
          if (parseFloat(obj.roce) >= kfgMAX) {
            kfgMAX = parseFloat(obj.roce);
          }
        }
        if (kfgTsr) {
          mappedObj.value4 = obj["debt-to-equity-ratio"];
          mappedObj.value4color = "#1EE9BD";
          if (parseFloat(obj["debt-to-equity-ratio"]) <= kfgMIN) {
            kfgMIN = parseFloat(obj["debt-to-equity-ratio"]);
          }
          if (parseFloat(obj["debt-to-equity-ratio"]) >= kfgMAX) {
            kfgMAX = parseFloat(obj["debt-to-equity-ratio"]);
          }
        }
        return mappedObj;
      })
      .reverse();

    return (
      <div styleName={`company-financial ${screen === 1 ? "invisible-section" : ""}`}>
        <div styleName="financial-data">
          <h2>Financial Data</h2>
          {sortedCombinedSnapshots.length > 1 && (
            <div styleName="graph-placeholder small-graph">
              <RankingTrendGraph
                graphData={financialGraphData}
                reversed={false}
                label={false}
                domain={[Math.floor(fgMIN - 0.1 * fgMIN), Math.ceil(fgMAX + 0.1 * fgMAX)]}
                graphExpand={graphExpand4}
                setGraphExpand={setGraphExpand4}
                dynamicOptions={dynamicOptionsFG}
              />
            </div>
          )}
          <div styleName="financial-data-options">
            {dynamicOptionsFG.map((obj, index) => {
              return (
                <React.Fragment key={index}>
                  <input
                    type="checkbox"
                    styleName={`checkbox ${obj.present ? "" : "grey-out"}`}
                    style={{ "--color": obj.color }}
                    checked={!obj.present ? false : obj.value}
                    onChange={() => obj.setvalue(!obj.value)}
                  />
                  <span styleName={`option-name ${obj.present ? "" : "grey-out"}`}>{obj.name}</span>
                </React.Fragment>
              );
            })}
          </div>
          {/*  */}
          <div styleName="table-container-wrapper">
            {/* Scroll Arrows Table 1 */}
            <>
              {!isMobile && canScrollLeft1 && (
                <button disabled={!canScrollLeft1} styleName="nav-button back" onClick={() => scrollTable("left")}>
                  <span styleName="svg-back">
                    <ArrowDashIcon height="26" width="26" viewBox="0 0 26 26" />
                  </span>
                </button>
              )}
              {!isMobile && canScrollRight1 && (
                <button styleName="nav-button next" onClick={() => scrollTable("right")}>
                  <span styleName="svg-next">
                    <ArrowDashIcon height="26" width="26" viewBox="0 0 26 26" />
                  </span>
                </button>
              )}
            </>
            {/*  */}
            <div styleName="table-container" ref={scrollContainerRef1}>
              <table styleName="financial-table">
                <thead>
                  <tr>
                    <th styleName="row1">PARAMETERS</th>
                    {sortedCombinedSnapshots
                      .filter((obj) =>
                        Object.values(obj).some((value) => value !== undefined && value !== null && value !== "-")
                      )
                      .map((obj, index) => (
                        <th key={index} styleName="row1 row">
                          {obj["generic-company-snapshot-year"]?.name}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: "Revenue ", value: "revenue", yoy: "revenue-yoy-chg" },
                    {
                      name: "Net Operating Income ",
                      value: "net-operating-income",
                      yoy: "net-operating-income-yoy-chg",
                    },
                    { name: "Profit ", value: "profit", yoy: "profit-yoy-chg" },
                    { name: "Assets ", value: "assets", yoy: "assets-yoy-chg" },
                    { name: "Net Worth ", value: "networth", yoy: "networth-yoy-chg" },
                    { name: "Employee Cost ", value: "employee-cost", yoy: "employee-cost-yoy-chg" },
                    { name: "Interest Cost ", value: "interest-cost" },
                    { name: "Cash & Bank Balance ", value: "cash-bank-balance" },
                    { name: "Total Debt ", value: "total-debt" },
                  ]
                    .filter((item) =>
                      sortedCombinedSnapshots.some((obj) => {
                        const value = obj[item.value];
                        return value !== undefined && value !== null && value !== "-";
                      })
                    )
                    .map((item, index) => {
                      return (
                        <tr key={index}>
                          <td styleName="parameter-cell">
                            <span styleName="top">{item.name}</span>
                            <div styleName="currency-note">(INR Cr)</div>
                          </td>
                          {sortedCombinedSnapshots
                            .filter((obj) =>
                              Object.values(obj).some((value) => value !== undefined && value !== null && value !== "-")
                            )
                            .map((obj, index) => {
                              const valueToNum = obj[item.value]
                                ? parseInt(obj[item.value].replace(/,/g, ""), 10)
                                : "-";
                              return (
                                <td key={index}>
                                  {isNaN(valueToNum) ? (
                                    "-"
                                  ) : (
                                    <>
                                      {valueToNum}
                                      {item.yoy &&
                                        (isNaN(parseInt(obj[item.yoy])) ? (
                                          <div styleName="change">-</div>
                                        ) : (
                                          <div
                                            styleName={`change ${
                                              parseFloat(obj[item.yoy].toString().replace("%", "")) >= 0
                                                ? "positive"
                                                : "negative"
                                            }`}
                                          >
                                            {`${obj[item.yoy] > 0 ? "+" : ""}`}
                                            {obj[item.yoy]}
                                          </div>
                                        ))}
                                    </>
                                  )}
                                </td>
                              );
                            })}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
          {/*  */}
        </div>
        <div styleName="financial-data no-bottom-border">
          <h2 styleName="margin-top">Key Financial Ratios</h2>
          {sortedCombinedSnapshots.length > 1 && (
            <div styleName="graph-placeholder small-graph">
              <RankingTrendGraph
                graphData={keyfinancialGraphData}
                reversed={false}
                label={false}
                domain={[Math.floor(kfgMIN - 0.1 * kfgMIN), Math.ceil(kfgMAX + 0.1 * kfgMAX)]}
                graphExpand={graphExpand5}
                setGraphExpand={setGraphExpand5}
                dynamicOptions={dynamicOptionsKFG}
                extraOptions={true}
                threeLineOptions={true}
              />
            </div>
          )}
          <div styleName="financial-data-options">
            {dynamicOptionsKFG.map((obj, index) => {
              return (
                <React.Fragment key={index}>
                  <input
                    type="checkbox"
                    styleName={`checkbox ${obj.present ? "" : "grey-out"} ${
                      index === 1 ? "option-name-mobile" : index === 5 ? "option-name-desktop" : ""
                    }`}
                    style={{ "--color": obj.color }}
                    checked={!obj.present ? false : obj.value}
                    onChange={() => obj.setvalue(!obj.value)}
                  />
                  <span
                    styleName={`option-name ${obj.present ? "" : "grey-out"} ${
                      index === 1 ? "option-name-mobile" : index === 5 ? "option-name-desktop" : ""
                    }`}
                  >
                    {obj.name}
                  </span>
                </React.Fragment>
              );
            })}
          </div>
          <div styleName="table-container-wrapper">
            {/* Scroll Arrows Table 2 */}
            <>
              {!isMobile && canScrollLeft2 && (
                <button disabled={!canScrollLeft2} styleName="nav-button back" onClick={() => scrollTable2("left")}>
                  <span styleName="svg-back">
                    <ArrowDashIcon height="26" width="26" viewBox="0 0 26 26" />
                  </span>
                </button>
              )}
              {!isMobile && canScrollRight2 && (
                <button styleName="nav-button next" onClick={() => scrollTable2("right")}>
                  <span styleName="svg-next">
                    <ArrowDashIcon height="26" width="26" viewBox="0 0 26 26" />
                  </span>
                </button>
              )}
            </>
            {/*  */}
            <div styleName="table-container" ref={scrollContainerRef2}>
              <table styleName="financial-table">
                <thead>
                  <tr>
                    <th styleName="row1">PARAMETERS</th>
                    {sortedCombinedSnapshots
                      .filter((obj) =>
                        Object.values(obj).some((value) => value !== undefined && value !== null && value !== "-")
                      )
                      .map((obj, index) => (
                        <th key={index} styleName="row1 row">
                          {obj["generic-company-snapshot-year"]?.name}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: "Profit As % Of Revenues ", value: "profit-as-%-of-revenues" },
                    { name: "Profit As % Of Assets ", value: "profit-as-%-of-assets" },
                    { name: "Profit As % Of Networth ", value: "profit-as-%-of-networth" },
                    { name: "Interest Cost to EBITDA % ", value: "interest-cost-to-ebitda-%" },
                    { name: "Debt to Equity Ratio ", value: "debt-to-equity-ratio" },
                    { name: "RONW ", value: "ronw" },
                    { name: "ROCE ", value: "roce" },
                  ]
                    .filter((item) =>
                      sortedCombinedSnapshots.some((obj) => {
                        const value = obj[item.value];
                        return value !== undefined && value !== null && value !== "-";
                      })
                    )
                    .map((item, index) => (
                      <tr key={index}>
                        <td styleName="parameter-cell">
                          <span styleName="top">{item.name}</span>
                        </td>
                        {sortedCombinedSnapshots
                          .filter((obj) =>
                            Object.values(obj).some((value) => value !== undefined && value !== null && value !== "-")
                          )
                          .map((obj, index) => (
                            <td key={index}>{isNaN(parseInt(obj[item.value])) ? "-" : <>{obj[item.value]}</>}</td>
                          ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div styleName="parent-container">
      {companyStatics()}
      {screen === 1 && (
        <div styleName="company-overview">
          {(bio || yearOfIncorporation || headquarters || employees || owner || companyIndustry?.name || website) &&
            aboutCompany()}
          {featuredRankingBlock()}
          {sortedCombinedSnapshots.length > 0 && latestFinancialCards()}
          {(employeeCount || employeeYoY || employeeGraphData.length > 1) && (
            <section styleName="financial-employee-section">
              <h2>Employees Snapshot</h2>
              {(employeeCount || employeeYoY) && employeeData()}
              {employeeGraphData.length > 1 && (
                <div styleName="graph-placeholder">
                  <RankingTrendGraph
                    graphData={employeeGraphData}
                    title={"Employees Over Years "}
                    reversed={false}
                    graphExpand={graphExpand3}
                    setGraphExpand={setGraphExpand3}
                  />
                </div>
              )}
            </section>
          )}
          {tagResponse.total > 0 && (
            <section styleName="financial-employee-section no-bottom-border three-col-grid">
              <h3 styleName={`title ${tagResponse.total < 7 ? "no-read-more" : ""}`}>Fortune India Coverage</h3>
              <ThreeColGrid
                collection={entityStories}
                config={{
                  buttonText: "Read More",
                  footerButton: "SubsequentLoadCount",
                  showAuthor: true,
                  showTime: true,
                  showReadTime: false,
                }}
                isLoadMoreVisible={tagResponse.total > entityStories.length}
                sectionSwitch={sectionSwitch}
                initialLoadCount={6}
                isolatedLoadMore={true}
                page="company-page"
                showAuthorContent={false}
              />
            </section>
          )}
        </div>
      )}
      {(screen === 2 || screen === 1) && sortedCombinedSnapshots.length > 0 && screen2GraphsRenderer()}
      {tagResponse.total > 0 && screen === 3 && (
        <section styleName="company-news">
          <div styleName="grid three-col-grid-big">
            <ThreeColGrid
              collection={entityStoriesMax}
              config={{
                buttonText: "Read More",
                footerButton: "SubsequentLoadCount",
                showAuthor: true,
                showTime: true,
                showReadTime: false,
              }}
              isLoadMoreVisible={false}
              sectionSwitch={sectionSwitch}
              initialLoadCount={12}
              isolatedLoadMore={true}
              page="company-page"
              showAuthorContent={false}
            />
            {tagResponse.total > entityStoriesMax.length && (
              <div styleName="button-container">
                <div styleName="button" onClick={() => getMoreStories(offset)}>
                  Load More
                </div>
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
};

CompanyPage.propTypes = {
  data: PropTypes.array,
};

export { CompanyPage };
